import React, { useEffect, useMemo, useState } from "react";
import EmailsPanel from "./painel-email";
import PhonesPanel from "./painel-fone";
import CompaniesPanel from "./painel-company";

import ClipboardPermissionGate from "./clipboard-permission-gate";
import CompaniesHistoryPanel from "./painel-company-history";
import DeniedCompaniesPanel from "./painel-company-danied";
import { getCompanies } from "services/managerial/managerial-service";
import { Spin } from "antd";
import HorizontalScrollWrapper from "components/horizontal-scroll-wrapper";

const ManagerialCustomer = () => {
  const [loading, setLoading] = useState(true);
  const [companies, setCompanies] = useState([]);
  const [activeCompanies, setActiveCompanies] = useState([]);
  const [deniedCompanies, setDeniedCompanies] = useState([]);

  useEffect(() => {
    const active = companies.filter((c) => !c.isBan);
    const denied = companies.filter((c) => c.isBan);
    setActiveCompanies(active);
    setDeniedCompanies(denied);
  }, [companies]);

  useEffect(() => {
    getCompaniesData();
  }, []);
  const getCompaniesData = async () => {
    setLoading(true);

    try {
      const result = await getCompanies();
      setCompanies(result);
    } catch (error) {
      notificationErroInternalGeneric();
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container-managerial-customer">
      <Spin spinning={loading}>
          <HorizontalScrollWrapper style={{ minHeight: "90vh" }}>
            <EmailsPanel protectedView={true} />

            <PhonesPanel protectedView={true} />

            <CompaniesPanel
              protectedView={true}
              data={activeCompanies}
              setEmpresas={setCompanies}
            />

            <CompaniesHistoryPanel
              data={companies}
              setEmpresas={setCompanies}
            />

            <DeniedCompaniesPanel
              data={deniedCompanies}
              setEmpresas={setCompanies}
            />
          </HorizontalScrollWrapper>
      </Spin>
    </div>
  );
};

export default ManagerialCustomer;
